import React from 'react';
import OverWindow from '../../../Elements/OverWindow';
import ColButton from '../../../Elements/ColButton';
import { Paper } from '@mui/material';
import JsxHelper from '../../../Helpers/JsxHelper';
import TaxService from '../../../Services/TaxService';
import LookupItemService from '../../../Services/LookupItemService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import OfficeService from '../../../Services/OfficeService';

class DetailedTaxWindow extends React.Component {
  static defaultProps = {
    clickOnCancel: () => {},
    clickOnEdit: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      taxItem: props.tax,
      saving: false,
      confirmed: false,
      window: null,
      office: '',
      paidby: '',
    };
    this.openEditWindow = this.openEditWindow.bind(this);
  }

  componentDidMount() {
    OfficeService.GetOfficeNameById(this.state.taxItem.OfficeId)
      .then((result) => (result ? this.setState({ office: result }) : '-'))
      .catch(() => ErrorMessage.SetErrorMessage('DTW35'));

    LookupItemService.GetLookupItemByLookupIdAndLookupValue(80, this.state.taxItem.TaxesPaidBy)
      .then((result) => this.setState({ paidby: result.text }))
      .catch(() => ErrorMessage.SetErrorMessage('DTW39'));
  }

  deleteTaxFunction() {
    let tempItem = this.state.taxItem;
    tempItem.Inactive = !tempItem.Inactive;
    this.setState({
      taxItem: tempItem,
      saving: true,
    });
    TaxService.DeleteTax(tempItem.TaxId)
      .then((result) => {
        this.setState({ saving: false });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: DTW67');
        this.setState({ saving: false });
      });
  }

  renderCell(width, label, data) {
    if (typeof data === 'boolean') {
      data = JsxHelper.YesNo(data);
    }
    return (
      <div className={width + ' '}>
        <div className='container border rounded  hover m-1 p-1'>
          <div className='row'>
            <div className='col-6'>{label}</div>
            <div className={'col-6 ' + (typeof data === 'boolean') ? 'text-center' : ''}>{data}</div>
          </div>
        </div>
      </div>
    );
  }
  openEditWindow() {
    this.props.clickOnEdit();
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={() => this.props.clickOnCancel(false)}
        title='Detailed Tax Information'
        closeOnClickOutside={false}
      >
        <div className=' p-1 m-1'>
          <div className='container-fluid m-3'>
            <div className='row justify-content-center'>
              <Paper
                elevation={6}
                className='border p-1 m-1'
              >
                <div className='container p-3'>
                  <h3 className='text-center m-2'>{'Tax'}</h3>
                  <div className='row'>
                    {this.renderCell('col-6', 'Tax Name', this.state.taxItem.Name)}
                    {this.renderCell('col-6', 'Apply To Assignment Fees?', this.state.taxItem.ApplyToAssignmentFees)}
                    {this.renderCell('col-6', 'Rate %', this.state.taxItem.Rate)}
                    {this.renderCell(
                      'col-6',
                      'Apply To Assignment Reimbursements? ',
                      this.state.taxItem.ApplyToAssignmentReimbursements
                    )}
                    {this.renderCell('col-6', 'Tax Office', this.state.office)}
                    {this.renderCell('col-6', 'Apply To Line Item Fees?', this.state.taxItem.ApplyToLineItemFees)}
                    {this.renderCell('col-6', 'Taxes Paid By', this.state.paidby)}
                    {this.renderCell(
                      'col-6',
                      'Apply To Line Item Reimbursements?',
                      this.state.taxItem.ApplyToLineItemReimbursements
                    )}
                    {this.renderCell('col-6', '3rd Party Name', this.state.taxItem.ThirdPartyName)}
                    {this.renderCell('col-6', 'Apply To Prepay Fees?', this.state.taxItem.ApplyToFeePrepayments)}
                    {this.renderCell('col-6', 'Description', this.state.taxItem.Description)}
                    {this.renderCell(
                      'col-6',
                      'Apply to Prepay Reimbursements?',
                      this.state.taxItem.ApplyToReimbursementPrepayments
                    )}
                    {this.renderCell('col-6', 'Item Code', this.state.taxItem.ItemCode)}
                    {this.renderCell('col-6', 'Is Active?', !this.state.taxItem.Inactive)}
                  </div>
                </div>
              </Paper>
            </div>
          </div>
          {this.props.showEdit ? (
            <div className='container'>
              <div className='row'>
                <ColButton
                  text='Edit'
                  icon={'fa-solid fa-edit'}
                  onClick={this.openEditWindow}
                  disabled={this.saving}
                  roleKey='home_offices_edit'
                />
                <ColButton
                  type='button'
                  text='Cancel'
                  onClick={this.props.clickOnCancel}
                  icon={'fa-solid fa-circle-xmark'}
                />
              </div>
            </div>
          ) : (
            <div className='container'>
              <div className='row'>
                <ColButton
                  type='button'
                  text='Remove Tax'
                  onClick={() => {
                    this.deleteTaxFunction(this);
                    this.props.clickOnCancel();
                  }}
                  icon='fa fa-trash'
                  disabled={this.state.saving}
                  roleKey='home_offices_edit'
                />
                <ColButton
                  type='button'
                  text='Cancel'
                  onClick={this.props.clickOnCancel}
                  icon={'fa-solid fa-circle-xmark'}
                />
              </div>
            </div>
          )}
        </div>
        {this.state.window}
      </OverWindow>
    );
  }
}

export default DetailedTaxWindow;
